import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { authClient, useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { sfx } from "@/lib/sounds";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { navigate("/", { replace: true }); return; }
    (async () => {
      try {
        await authClient.post("/auth/google/session", { session_id: sessionId });
        await refresh();
        sfx.levelup();
        toast.success("Signed in with Google");
        // Clean the hash and redirect
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/profile", { replace: true });
      } catch (err) {
        sfx.error();
        toast.error("Google sign-in failed");
        navigate("/", { replace: true });
      }
    })();
  }, [location, navigate, refresh]);

  return (
    <div className="min-h-screen grid place-items-center bg-black text-white">
      <div className="rounded-2xl glass px-8 py-6 flex items-center gap-3">
        <span className="w-3 h-3 rounded-full bg-[#FFBF00] animate-pulse" />
        <span className="text-sm uppercase tracking-widest">Completing sign-in…</span>
      </div>
    </div>
  );
}
